import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px 20px;
  margin-bottom: 50px;
`;

export default Container;
